import { createUseStyles } from 'react-jss';
import { DESKTOP_FONT_SIZES, DESKTOP_SIZES_BREAKPOINT, MOBILE_FONT_SIZES, } from '@/styles/themes/components';
export const useStyles = createUseStyles((theme) => ({
    header: {
        display: 'flex',
        gap: 20,
        flexDirection: 'column-reverse',
        [theme.breakpoints.up('lg')]: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
    },
    authBlock: {
        display: 'flex',
        padding: '8px 12px',
        alignItems: 'flex-start',
        gap: 8,
        borderRadius: 8,
        background: '#F4F5F7',
        cursor: 'pointer',
    },
    authImage: {
        height: 14,
        width: 14,
        marginTop: 4,
    },
    authTitle: {
        fontSize: MOBILE_FONT_SIZES.main,
        color: theme.colors.brand,
        fontWeight: 700,
        marginBottom: 2,
        [theme.breakpoints.up(DESKTOP_SIZES_BREAKPOINT)]: {
            fontSize: DESKTOP_FONT_SIZES.main,
        },
    },
    authText: {
        fontSize: MOBILE_FONT_SIZES.small,
        color: theme.colors.textPrimary,
        [theme.breakpoints.up(DESKTOP_SIZES_BREAKPOINT)]: {
            fontSize: DESKTOP_FONT_SIZES.small,
        },
    },
    passenger: {
        display: 'flex',
        flexDirection: 'column',
        '& > div': {
            marginBottom: '6px',
        },
        marginTop: '14px',
        [theme.breakpoints.up('lg')]: {
            marginTop: '0px',
            '& > div': {
                marginBottom: '6px',
            },
            display: 'grid',
            gridTemplateColumns: '6fr 6fr 3fr',
            gap: '0px 6px',
        },
    },
    birthdayWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        [theme.breakpoints.up('lg')]: {
            flexDirection: 'row',
            gap: '0px',
        },
    },
    passengerbirthday: {
        flexGrow: 1,
        marginBottom: '6px',
        [theme.breakpoints.up('lg')]: {
            marginBottom: '0px',
        },
    },
}), { name: 'passenger' });
